import { render, staticRenderFns } from "./editOrderModel.vue?vue&type=template&id=70af39af&scoped=true&"
import script from "./editOrderModel.vue?vue&type=script&lang=js&"
export * from "./editOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./editOrderModel.vue?vue&type=style&index=0&id=70af39af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af39af",
  null
  
)

export default component.exports